(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-acquisto-info"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.fsSpedizioneInit) return;
    window.fsSpedizioneInit = true;

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    function euro(cents) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }

    function aggiorna(cart) {
      document.querySelectorAll('[data-fs-spedizione]').forEach(function (box) {
        var soglia = parseInt(box.dataset.soglia, 10) || 3900;
        var mancante = soglia - cart.total_price;
        var perc = Math.min(100, Math.round((cart.total_price * 100) / soglia));
        var testo = box.querySelector('[data-fs-spedizione-testo]');
        var barra = box.querySelector('[role="progressbar"]');

        if (cart.item_count === 0) {
          testo.innerHTML = 'Spedizione gratuita per ordini da <strong>' + euro(soglia) + '</strong>.';
        } else if (mancante > 0) {
          testo.innerHTML = 'Ti mancano <strong>' + euro(mancante) + '</strong> per la spedizione gratuita.';
        } else {
          testo.innerHTML = '<strong>Hai la spedizione gratuita</strong> su questo ordine.';
        }
        box.classList.toggle('is-completa', mancante <= 0 && cart.item_count > 0);
        barra.style.setProperty('--progress', perc + '%');
        barra.setAttribute('aria-valuenow', perc);
      });
    }

    function ricarica() {
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(aggiorna)
        .catch(function () {});
    }

    // Ogni aggiunta al carrello (form del tema o quick add) aggiorna la barra.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form.action && form.action.indexOf('/cart/add') > -1) {
        setTimeout(ricarica, 1200);
      }
    }, true);

    ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (evento) {
      document.addEventListener(evento, ricarica);
    });

    // Tornando indietro con il browser la pagina può essere servita dalla cache.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) ricarica();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
